import { Dialog, DialogContent, DialogTitle } from "@capacit-com/lara-law-shared-ui";
import { User } from "@/models/users/User";
import UserAvatar from "@/components/images/UserAvatar";
import { formatUsersName } from "@/utils/format";

interface SharedAccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  sharedUserIds: string[];
  tenantUsers: User[];
}

const SharedAccessDialog = ({
  open,
  onOpenChange,
  sharedUserIds,
  tenantUsers,
}: SharedAccessDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined}>
        <div className="flex flex-col gap-2">
          <DialogTitle>
            <div className="font-semibold text-sm">Delt adgang:</div>
          </DialogTitle>
          <div className="flex flex-col gap-2 max-h-64 overflow-y-auto">
            {sharedUserIds.map((userId) => {
              const user = tenantUsers.find((u) => u.id === userId);
              if (!user) return null;
              return (
                <div key={userId} className="flex items-center gap-2">
                  <UserAvatar
                    user={user}
                    avatarClassName="size-6 border-2 border-white"
                  />
                  <span className="text-sm">{formatUsersName(user)}</span>
                </div>
              );
            })}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SharedAccessDialog;
